import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Router } from '@angular/router';
import {
    TileOption,
    TileQuestion,
} from './_subs/tile-question/tile-question.component';
import {
    PillQuestion,
    PillOption,
} from './_subs/pill-question/pill-question.component';
import { OnboardingService } from '../../../../shared/services/onboarding.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { FaqCardModel } from 'src/app/views/partials/faq-card/faq-card.component';
import { KycService } from '../../../../shared/services/kyc.service';

@Component({
    selector: 'app-questions',
    templateUrl: './questions.component.html',
    styleUrls: ['./questions.component.scss'],
})
export class QuestionsComponent implements OnInit {
    @Output() newOptionId = new EventEmitter<any>();
    result: any;
    option: any[];
    elem: any[] = [];
    questionId: number;
    optionId: string;
    response: any;
    arr: any[];
    optionWeight: any;
    risk: boolean = false;
    subject: any;
    advisoryObject:any ={};

    onboardingGroups = [
        // {
        //     name: 'Risk Profile',
        //     id: 6,
        //     status: 'incomplete',
        // },
    ];

    faqQuestions: FaqCardModel = {
        title: 'Common Question',
        faqs: [
            {
                question: 'Welcome To Advisor',
                answer: 'We are offering you free money :D',
            },
            {
                question: 'Welcome To Advisor',
                answer: 'We are offering you free money :D',
            },
            {
                question: 'Welcome To Advisor',
                answer: 'We are offering you free money :D',
            },
            {
                question: 'Welcome To Advisor',
                answer: 'We are offering you free money :D',
            },
        ],
    };

    currentSection = 1;

    isCardComplete = false;

    question: TileQuestion = {
        question: 'Question 1',
        description: 'Select 1 of the 3 options',
    };

    // tslint:disable-next-line:max-line-length
    options: TileOption[] = [
        {
            text: 'Text 1',
            value: 1,
            id: '1',
        },
        {
            text: 'Text 2',
            value: 3,
            id: '3',
        },
        {
            text: 'Text 3',
            value: 2,
            id: '2',
        },
    ];
    // tslint:enable-next-line:max-line-length

    pillTitle = {
        text: 'Your Income',
        description: 'Select your preferred option',
    };

    pillQuestions: PillQuestion = {
        id: 1,
        title: 'What is the value of you pre-tax Annual income?',
    };

    pillOption: PillOption[] = [
        {
            text: 'No experience',
            value: 1,
        },
        {
            text: 'Short term 1-3 years',
            value: 2,
        },
        {
            text: '>50M',
            value: 3,
        },
    ];
    questionCategory: any;
    newoptionId: any;
    wallet: any;
    productType: any;
    walletId: any;

    goToNextSection(index: number) {
        if (this.currentSection === this.onboardingGroups.length) {
            this.router.navigate(['risk-profile'], { relativeTo: this.route });
            return true;
        }
        this.currentSection = index + 1;
    }

    setItemClass(item) {
        if (item) {
            const classes = {
                complete: item.complete,
                active: this.currentSection === item.id,
            };
            return classes;
        }
    }

    changeOption(option) {
        this.optionId = option.id;
        this.optionWeight = option.value;
    }

    //check if its user first time or not
    check() {
        this.SpinnerService.show();
        this.api.getResponse().subscribe((res: any) => {
            this.response = res.data.length;
            
            if (this.response == 0) {
                this.non_scoreQuestion();
                this.Profile();
                
            } else {
                this.getNext();
            }
            setTimeout(() => {
                /** spinner ends after 5 seconds */
                this.SpinnerService.hide();
              }, 1000);
        });
    }

    //get user Profile
    Profile(){
        this.kyc.getProfile()
        .subscribe((res:any)=>{
            if(res.code == 200){
                this.walletId= res.data.userId;
                this.fetchWallet();
            }
        },err=>{
            this.kyc.onboard(null,null,"ADVISORY")
                .subscribe((res:any)=>{
            })
        })
    }

    //get Wallet
    fetchWallet(){
        this.route.params.subscribe(params =>{
            this.kyc.getWallet(this.walletId)
            .subscribe((res:any)=>{
                this.wallet = res.data;
                // console.log(this.wallet,'user')
                if(this.wallet.length != 0){
                   this.wallet.forEach(element => {
                   this.productType = element.productType;
                   this.productType= [this.productType].concat(element.productType);
               
                   });

                   if(this.productType.includes("ADVISORY")){
                    console.log('wallet exists for user');
                    }
                    else{
                        this.advisoryObject["productType"]="ADVISORY";
                        this.kyc.updateKYC(this.advisoryObject)
                        .subscribe((res:any)=>{
                            console.log('wallet created');
                        })
                    }

                }
    
            })
        })
        
    }

    updateRiskProfile(){
        this.advisoryObject["portfolioType"]="CONSERVATIVE";
        this.kyc.updateKYC(this.advisoryObject)
            .subscribe((res:any)=>{
                if(res.success == true){
                    this.router.navigate(['../risk-profile'], {
                        relativeTo: this.route,
                    });
                }
                else{
                    this.toastr.info(
                        'Failed to calculate your risk profile',
                        'Something went wrong',
                        {
                            positionClass: 'toast-top-center',
                            timeOut: 3000,
                        }
                    );
                    this.router.navigate(['/onboarding/menu']);
                }
            })
    }

    // get questions by category
    getQuestion() {
        this.route.params.subscribe((params: Params) => {
            const category = 'WILLINGNESS';

            this.api.question(category).subscribe((res: any) => {
                this.result = res.data;
                this.result = this.result[0];

                //convert into an array
                this.option = Array.of(this.result.options);

                this.question.question = this.result.question;
                this.questionId = this.result.id;
                this.questionCategory = this.result.category;
                this.option.forEach((element: any) => {
                    this.options = [];
                    element.forEach((elem) => {
                        this.options.push({
                            value: elem.weight,
                            text: elem.text,
                            id: elem.id,
                        });
                    });
                });
            });
        });
    }

    reverseQuestion() {
        this.route.params.subscribe((params: Params) => {
            const category = 'WILLINGNESS';

            this.api.question(category).subscribe((res: any) => {
                this.result = res.data;
                this.result = this.result.reverse();

                this.result = this.result[0];

                //convert into an array
                this.option = Array.of(this.result.options);

                this.question.question = this.result.question;
                this.questionId = this.result.id;
                this.questionCategory = this.result.category;
                this.option.forEach((element: any) => {
                    this.options = [];
                    element.forEach((elem) => {
                        this.options.push({
                            value: elem.weight,
                            text: elem.text,
                            id: elem.id,
                        });
                    });
                });
            });
        });
    }

    //Get question by capacity
    capacityQuestion() {
        this.api.capacityQuestion().subscribe((res: any) => {
            this.result = res.data;
            this.result = this.result[0];

            //convert into an array
            this.option = Array.of(this.result.options);

            this.question.question = this.result.question;
            this.questionId = this.result.id;
            this.questionCategory = this.result.category;

            this.option.forEach((element: any) => {
                this.options = [];
                element.forEach((elem) => {
                    this.options.push({
                        value: elem.weight,
                        text: elem.text,
                        id: elem.id,
                    });
                });
            });
        });
    }

    // get questions by category
    non_scoreQuestion() {
        this.route.params.subscribe((params: Params) => {
            const category = 'NON_SCORE';

            this.api.question(category).subscribe((res: any) => {
                this.result = res.data;
                this.result = this.result[0];

                //convert into an array
                this.option = Array.of(this.result.options);

                this.question.question = this.result.question;
                this.questionId = this.result.id;
                this.questionCategory = this.result.category;

                this.option.forEach((element: any) => {
                    this.options = [];
                    element.forEach((elem) => {
                        this.options.push({
                            value: elem.weight,
                            text: elem.text,
                            id: elem.id,
                        });
                    });
                });
            });
        });
    }

    //submit response
    submitResponse() {
        if (
            this.optionId == null ||
            this.optionId === '' ||
            this.optionId == undefined
        ) {
            this.toastr.info('Please select an option!', 'Empty Response!', {
                positionClass: 'toast-top-center',
                timeOut: 3000,
            });
        } else {
            this.SpinnerService.show();
            this.api
                .submitResponse(this.questionId, this.optionId)
                .subscribe((res: any) => {
                    if (
                        res.data.category == 'CAPACITY' &&
                        res.data.weight == 0
                    ) {
                        this.updateRiskProfile();
                        // this.currentSection = 6;
                    } else {
                        this.getNext();
                    }
                    this.SpinnerService.hide();
                });
        }
    }

    //get next question
    getNext() {
        this.optionId = '';
        this.api.getNextQuestion().subscribe((res: any) => {
            if (res.code == 'Non_score204' && res.success == false) {
                this.getQuestion();
            } else if (res.code == 'Willingness204' && res.success == false) {
                this.capacityQuestion();
            } else if (res.code == 'Capacity204' && res.success == false) {
                this.api.riskProfile()
                    .subscribe((res:any)=>{
                        console.log(res,'result')
                        if(res.success == true){
                            this.router.navigate(['../risk-profile'], {
                                relativeTo: this.route,
                            });
                        }
                        else{
                            this.toastr.info(
                                'Failed to calculate your risk profile',
                                'Something went wrong',
                                {
                                    positionClass: 'toast-top-center',
                                    timeOut: 3000,
                                }
                            );
                            this.router.navigate(['/onboarding/menu']);
                        }
                    });
                
            }

            //fetch next question
            else {
                this.result = res.data;
                this.result = this.result[0];

                //convert into an array
                this.option = Array.of(this.result.options);

                this.question.question = this.result.question;
                this.questionId = this.result.id;
                this.questionCategory = this.result.category;
                this.option.forEach((element: any) => {
                    this.options = [];

                    element.forEach((elem) => {
                        this.options.push({
                            value: elem.weight,
                            text: elem.text,
                            id: elem.id,
                        });
                    });
                });
            }
        });
    }

    //fetch all subjects
    getSubjects() {
        this.api.fetchSujects().subscribe((res: any) => {
            this.subject = res.data;

            let position = this.onboardingGroups.shift();

            this.subject.forEach((element) => {
                this.onboardingGroups.push({
                    name: element.subjectName,
                    id: element.id,
                    status: element.status,
                });
            });
            this.onboardingGroups.push(position);
        });
    }

    prevQuestion() {
        this.route.params.subscribe((params: Params) => {
            let Id = this.questionId;
            let category = this.questionCategory;

            this.SpinnerService.show();
            this.api.previousQuestion(Id, category).subscribe((res: any) => {
                this.result = res.data;
                if (this.result.length == 0 && category == 'WILLINGNESS') {
                    this.non_scoreQuestion();
                } else if (this.result.length == 0 && category == 'CAPACITY') {
                    this.reverseQuestion();
                } else if (category == 'NON_SCORE') {
                    this.toastr.info(
                        'No Previous Question Exists',
                        'No Question',
                        {
                            positionClass: 'toast-top-center',
                            timeOut: 3000,
                        }
                    );
                } else {
                    this.result = this.result[0];

                    //convert into an array
                    this.option = Array.of(this.result.options);

                    this.question.question = this.result.question;
                    this.questionId = this.result.id;
                    this.questionCategory = this.result.category;
                    this.option.forEach((element: any) => {
                        this.options = [];
                        element.forEach((elem) => {
                            this.options.push({
                                value: elem.weight,
                                text: elem.text,
                                id: elem.id,
                            });
                        });
                    });
                    this.fetchResByQuestionId();
                }
                this.SpinnerService.hide();
            });
        });
    }

    fetchResByQuestionId() {
        let questionId = this.questionId;
        this.api.fetchResponseByQuestionId(questionId).subscribe((res: any) => {
            this.result = res.data.length;
            this.optionId = res.data[0].weight;
            // this.newOptionId.emit(this.optionId);

            if (this.result != 0) {
            } else {
                this.submitResponse();
            }
        });
    }

    constructor(
        private api: OnboardingService,
        private route: ActivatedRoute,
        private router: Router,
        private kyc: KycService,
        private SpinnerService: NgxSpinnerService,
        private toastr: ToastrService
    ) {}

    ngOnInit() {
        this.check();
        this.getSubjects();
    }
}
